module.exports = __webpack_public_path__ + "static/media/bi_mascot_vic.b7b5169a.png";